import React from 'react';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  isLoading,
  loadingText,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmDisabled = false,
  variant = 'danger', // 'danger' | 'warning' | 'primary'
  wide = false // widen the modal for content that needs more room (e.g. side-by-side comparisons)
}) => {
  if (!isOpen) return null;

  const variantStyles = {
    danger: 'bg-red-600 hover:bg-red-700 focus:ring-red-500',
    warning: 'bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500',
    primary: 'bg-jims-cyan hover:bg-jims-cyan-dark focus:ring-jims-cyan'
  };

  const buttonClass = variantStyles[variant] || variantStyles.danger;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 h-full w-full z-50 flex justify-center items-center p-4">
      {/* Flex column capped at 90vh: title and buttons stay put, only the body scrolls. */}
      <div className={`relative mx-auto border w-full ${wide ? 'max-w-3xl' : 'max-w-md'} shadow-lg rounded-md bg-white flex flex-col max-h-[90vh]`}>
        <h3 className="text-lg leading-6 font-medium text-gray-900 flex-shrink-0 px-5 pt-5 pb-2 text-center">{title}</h3>
        <div className="px-7 py-3 overflow-y-auto flex-1 min-h-0 text-center">
          <p className="text-sm text-gray-500">{message}</p>
        </div>
        <div className="items-center px-5 py-3 space-x-3 flex justify-end flex-shrink-0 border-t border-gray-200">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading || confirmDisabled}
              className={`px-4 py-2 text-white rounded transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center ${buttonClass}`}
            >
              {isLoading ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  {loadingText || 'Processing...'}
                </>
              ) : confirmText}
            </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
